import { Mapper } from 'master-locations-library/master-locations-library/src/lib/core/base';
import {
  Job,
  Location,
} from 'master-locations-library/master-locations-library/src/lib/core/domain/models/master-plan';
import { JobWebEntity } from './job-web-entity';
import { LocationWebEntityForMasterPlan } from './location-web-entity';
import { DateTime, Duration } from 'luxon';

export class JobWebEntityyMapper extends Mapper<JobWebEntity, Job> {
  override mapTo(param: Job): JobWebEntity {
    throw new Error('Method not implemented.');
  }
  mapFrom(param: JobWebEntity): Job {
    return {
      id: param.id,
      jobNumber: param.jobNumber,
      planDay: param.planDay,
      jobName: param.jobName,
      jobColor: param.jobColor,
      vehicleType: param.vehicleType,
      startTerminalName: param.startTerminalName,
      endTerminalName: param.endTerminalName,
      startTime: param.startTime,
      endTime: param.endTime,
      startLatitude: param.startLatitude,
      startLongitude: param.startLongitude,
      endLatitude: param.endLatitude,
      endLongitude: param.endLongitude,
      planId: param.planId,
      planName: param.planName,
      locationsCount: param.locationsCount,
      isScheduled: param.isScheduled,
      wayPoints: param.wayPoints,
      distributionAreaId: param.distributionAreaId,
      distributionAreaName: param.distributionAreaName,
      distance: param.distance,
      duration: Duration.fromMillis(param.duration ?? 0),
      isPlanCommitted: param.isPlanCommitted,
      locations: param.locations?.map(
        (location: LocationWebEntityForMasterPlan): Location => ({
          id: location.id,
          planId: location.planId,
          planName: location.planName,
          locationId: location.locationId,
          jobId: location.jobId,
          jobNumber: location.jobNumber,
          template: location.template,
          locationName: location.locationName,
          latitude: location.latitude,
          longitude: location.longitude,
          address: location.address,
          postalCode: location.postalCode,
          city: location.city,
          country: location.country,
          stopTime: location.stopTime,
          serviceTime: location.serviceTime,
          activityName: location.activityName,
          pickupCapacityType1: location.pickupCapacityType1,
          pickupCapacityType2: location.pickupCapacityType2,
          pickupCapacityType3: location.pickupCapacityType3,
          deliveryCapacityType1: location.deliveryCapacityType1,
          deliveryCapacityType2: location.deliveryCapacityType2,
          deliveryCapacityType3: location.deliveryCapacityType3,
          precedence: location.precedence,
          qualifications: location.qualifications,
          openHours: location.openHours,
          stopNumber: location.stopNumber,
          sequenceNumber: location.sequenceNumber,
          servicesCount: location.servicesCount,
          arrivalTime: location.arrivalTime ? DateTime.fromISO(location.arrivalTime.toString()) : undefined,
          departureTime: location.departureTime ? DateTime.fromISO(location.departureTime.toString()) : undefined,
          distributionLaneId: location.distributionLaneId,
          isScheduled: location.isScheduled,
          isStartTerminal: location.isStartTerminal,
          isEndTerminal: location.isEndTerminal,
          isExists: false,
          istrue :false,
          locationAdditionalInfo: location.locationAdditionalInfo,
          productAdditionalInfo: location.productAdditionalInfo,
          tenantLocationId: location.tenantLocationId,
          shouldVisitIfNoService: location.shouldVisitIfNoService,
          segment: location.segment,
          productId: location.productId,
          prodId: location.prodId,
          productName: location.productName,
          createdAt: location.createdAt,
        })
      ),
    };
  }

  // mapTo(param: Job): JobWebEntity {
  //   return {
  //     id: param.id,
  //     jobNumber: param.jobNumber,
  //     planDay: param.planDay,
  //     jobName: param.jobName,
  //     jobColor: param.jobColor,
  //     vehicleType: param.vehicleType,
  //     startTerminalName: param.startTerminalName,
  //     endTerminalName: param.endTerminalName,
  //     startTime: param.startTime,
  //     endTime: param.endTime,
  //     startLatitude: param.startLatitude,
  //     startLongitude: param.startLongitude,
  //     endLatitude: param.endLatitude,
  //     endLongitude: param.endLongitude,
  //     planId: param.planId,
  //     planName: param.planName,
  //     locationsCount: param.locationsCount,
  //     isScheduled: param.isScheduled,
  //     wayPoints: param.wayPoints,
  //     distributionAreaId: param.distributionAreaId,
  //     distributionAreaName: param.distributionAreaName,
  //     distance: param.distance,
  //     duration: param.duration?.toMillis(),
  //     isPlanCommitted: param.isPlanCommitted,
  //     locations: param.locations?.map(
  //       (location: LocationWebEntityForMasterPlan): Location => ({
  //         id: location.id,
  //         planId: location.planId,
  //         planName: location.planName,
  //         locationId: location.locationId,
  //         jobId: location.jobId,
  //         jobNumber: location.jobNumber,
  //         template: location.template,
  //         locationName: location.locationName,
  //         latitude: location.latitude,
  //         longitude: location.longitude,
  //         address: location.address,
  //         postalCode: location.postalCode,
  //         city: location.city,
  //         country: location.country,
  //         stopTime: location.stopTime,
  //         serviceTime: location.serviceTime,
  //         activityName: location.activityName,
  //         pickupCapacityType1: location.pickupCapacityType1,
  //         pickupCapacityType2: location.pickupCapacityType2,
  //         pickupCapacityType3: location.pickupCapacityType3,
  //         deliveryCapacityType1: location.deliveryCapacityType1,
  //         deliveryCapacityType2: location.deliveryCapacityType2,
  //         deliveryCapacityType3: location.deliveryCapacityType3,
  //         precedence: location.precedence,
  //         qualifications: location.qualifications,
  //         openHours: location.openHours,
  //         stopNumber: location.stopNumber,
  //         sequenceNumber: location.sequenceNumber,
  //         servicesCount: location.servicesCount,
  //         arrivalTime: location.arrivalTime ? DateTime.fromISO(location.arrivalTime.toString()) : undefined,
  //         departureTime: location.departureTime? DateTime.fromISO(location.departureTime.toString()) : undefined,
  //         distributionLaneId: location.distributionLaneId?.toString(),
  //         isScheduled: location.isScheduled,
  //         isStartTerminal: location.isStartTerminal,
  //         isEndTerminal: location.isEndTerminal,
  //         locationAdditionalInfo: location.locationAdditionalInfo,
  //         productAdditionalInfo: location.productAdditionalInfo,
  //         tenantLocationId: location.tenantLocationId,
  //         shouldVisitIfNoService: location.shouldVisitIfNoService,
  //         segment: location.segment,
  //         productId: location.prodId,
  //         prodId: location.prodId,
  //         productName: location.productName,
  //         createdAt: location.createdAt,
  //       })
  //     ),
  //   };
  // }
}
